import RolePermissionApi from "@/api/RolePermissionApi";

const RolePermissionStore = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    roleBindPermission({ commit }, data) {
      return RolePermissionApi.roleBindPermission(data);
    },
  },
};

export default RolePermissionStore;
